import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import LoginForm from "./LoginForm";
import EmailCheckForm from "./EmailCheckForm";
import SignUpForm from "./SignUpForm";
import Layout, { Main } from "../Layout";
import ResetPasswordForm from "./ResetPasswordForm";
import { useApi } from "../Api/ApiContext";
import { useAsync } from "react-use";
import { Col, Row, Spinner } from "reactstrap";
import Error404 from "../Error/Error404";
import SignUpSuccess from "./SignUpSuccess";
import ResetPasswordSuccess from "./ResetPasswordSuccess";
import UserInfoUpdateSuccess from "./UserInfoUpdateSuccess";
import useCelebritiesStore from "../store/CelebritiesStore";

const Authentication = () => {
  const { getMe } = useApi();
  const { loading, error, value: user } = useAsync(() => getMe());
  const location = useLocation();
  const { celebrities } = useCelebritiesStore();

  if (loading) {
    return (
      <Layout celebrities={celebrities?.items}>
        <Main>
          <Row>
            <Col lg={6} className="mx-auto text-center">
              <Spinner color={"danger"} />
            </Col>
          </Row>
        </Main>
      </Layout>
    );
  }

  return (
    <Layout
      backPath={{
        pathname:
          location.state && location.state.backPath
            ? location.state.backPath
            : "/",
      }}
      celebrities={celebrities?.items}
    >
      <Main>
        <Routes>
          <Route
            path="login"
            element={<>{user ? <Navigate to="/" /> : <LoginForm />}</>}
          />
          <Route path="check-email" element={<EmailCheckForm user={user} />} />
          <Route path="sign-up" element={<SignUpForm user={user} />} />
          <Route path="signup-success" element={<SignUpSuccess />} />
          <Route path="update-success" element={<UserInfoUpdateSuccess />} />
          <Route
            path="reset-password"
            element={<>{user ? <Navigate to="/" /> : <ResetPasswordForm />}</>}
          />
          <Route
            path="reset-password-success"
            element={<ResetPasswordSuccess />}
          />
          <Route path={"*"} element={<Error404 />} />
        </Routes>
      </Main>
    </Layout>
  );
};

export default Authentication;
